import historyReducer from '@src/features/history/redux/reducer';

export const HistoryFeatureReducers = {
  history: historyReducer,
};
